import React, { useState, useEffect } from "react";

import { Button, Table } from "reactstrap";

//Unform e componentes
import ModalViewArquivo from "@/frontend/componentes/ModalViewArquivo";
import Paginacao from "@/frontend/componentes/Paginacao";
import SpinnerLoading from "@/frontend/componentes/Spinner";

//Context
import { useAuth } from "@/frontend/context/auth";

//Common
import { TIPO_PAGAMENTO, TIPO_SOLICITACAO } from "@/common/constantes";
import { fn_formatarData } from "@/common/utils/date";
import { fn_agruparTotal, fn_formatarNumero } from "@/common/utils/util";
import { fn_getResultPaginado, PAGINACAO } from "@/common/utils/paginacao";

//Util
import { ICONES, ICONES_BOTAO, ICONES_SIIG } from "@/frontend/utils/icones";
import {
  fn_calcularTotaisPagamentos,
  fn_getJsxSituacaoPagamento,
} from "@/frontend/utils/siig/solicitacao";
import { fn_getPastaUploadSolicitacao } from "@/frontend/utils/file";
import { fn_getPathTenant } from "@/frontend/utils/sessao";
import { fn_getPaginaNumPag } from "@/frontend/utils/util";

//API
import { api_listar, ROTA_LISTAR } from "@/frontend/services/api/api_list";
import {
  api_findByPk,
  ROTA_FIND_BY_PK,
} from "@/frontend/services/api/api_find";

//Telas
import TRateio_det from "../rateio/rateio_det";
import TPag_det_posse from "./pag_det_posse";
import TImpostos_cad from "../../cadastro_solicitacao/aba_pagamentos/cad/impostos_cad";

function TPagamentos_list({ solicitacao, numPag }) {
  const { sessaoUsuario } = useAuth();

  const isParcelado = solicitacao.tipo_pagamento == TIPO_PAGAMENTO.PARCELADO;

  //A coluna Data pagamento só é apresentada na solicitação de receita
  const isReceita = solicitacao.tipo == TIPO_SOLICITACAO.RECEITA;

  //### USE STATE ###
  const [modalOpenImpostos, setModalOpenImpostos] = useState(false);
  const [modalOpenRateio, setModalOpenRateio] = useState(false);
  const [modalOpenPagDet, setModalOpenPagDet] = useState(false);
  const [modalOpenDoc, setModalOpenDoc] = useState(false);

  const [pagamentos, setPagamentos] = useState([]);

  const [pageNumber, setPageNumber] = useState(1);
  const [result, setResult] = useState({
    pages: 0,
    count: 0,
    items: [],
    offset: 0,
    limit: 0,
  });

  const [totais, setTotais] = useState({});
  const [pagamentoCons, setPagamentoCons] = useState(null);
  const [nomeAnexoView, setNomeAnexoView] = useState(null);

  const [loading, setLoading] = useState(false);

  //### USE EFFECT ###
  //Inicialização da tela
  useEffect(() => {
    //Carrega os pagamentos da solicitação
    async function loadPagamentos() {
      let pagamentos = [];

      setLoading(true);

      //1 - Se a solicitação já vier com a lista de pagamentos
      if (solicitacao.pagamentos) {
        pagamentos = solicitacao.pagamentos;
      }
      //2 - Se tiver que buscar os pagamentos
      //OBS: A lista traz só os dados do pagamento (o grid e os totais não usam o restante).
      //     Os dados completos (rateio, impostos, conferências...) são buscados ao abrir o detalhe de um pagamento,
      //     pois trazer o completo de todos deixava a consulta lenta em solicitação com muitos pagamentos.
      else {
        pagamentos = await api_listar(
          ROTA_LISTAR.PAGAMENTOS_SOLICITACAO,
          `id_solicitacao=${solicitacao.id}`,
          //`id_solicitacao=${solicitacao.id}&include_completo=S`,
        );
      }

      setPagamentos(pagamentos);
      setTotais(fn_calcularTotaisPagamentos(pagamentos));

      if (numPag) {
        const page = fn_getPaginaNumPag(numPag);
        setPageNumber(page);
      }
      setLoading(false);
    }

    loadPagamentos();
  }, [solicitacao]);

  //Paginação
  useEffect(() => {
    setResult(
      fn_getResultPaginado(
        pageNumber,
        pagamentos,
        PAGINACAO.ITENS_POR_PAGINA_POPUP,
      ),
    );
  }, [pagamentos, pageNumber]);

  //### FUNÇÕES ###
  //Retorna o pagamento com os dados completos (rateio, impostos, conferências...), buscando no servidor
  //quando o pagamento da lista ainda não tem. Retorna null se não conseguir consultar.
  async function getPagamentoCompleto(pag) {
    //Já veio completo (lista recebida na solicitação) ou já foi consultado
    if (pag.rateio && pag.impostos) {
      return pag;
    }

    const pagCompleto = await api_findByPk(
      ROTA_FIND_BY_PK.SOLICITACAO_PAG,
      pag.id,
    );

    if (!pagCompleto) {
      return null;
    }

    //Mantém os dados que só a lista traz (Ex: nome dos anexos)
    const pagamento = { ...pag, ...pagCompleto };

    //Guarda na lista para não consultar de novo
    setPagamentos((prev) =>
      prev.map((item) => (item.id == pagamento.id ? pagamento : item)),
    );

    return pagamento;
  }

  //### EVENTOS ###
  //OnClick - Botão Impostos
  async function handleBotaoImpostos(pag) {
    const pagamento = await getPagamentoCompleto(pag);

    if (pagamento) {
      setPagamentoCons(pagamento);
      setModalOpenImpostos(true);
    }
  }

  //OnClick - Botão Rateio
  async function handleBotaoRateio(pag) {
    const pagamento = await getPagamentoCompleto(pag);

    if (pagamento) {
      setPagamentoCons(pagamento);
      setModalOpenRateio(true);
    }
  }

  //OnClick - Botão Consultar
  async function handleBotaoDetalharPagamento(pag) {
    const pagamento = await getPagamentoCompleto(pag);

    if (pagamento) {
      setPagamentoCons(pagamento);
      setModalOpenPagDet(true);
    }
  }

  //OnClick - Botão Visualizar documento
  function handleBotaoVisualizarDocs(nomeArquivo) {
    setNomeAnexoView(nomeArquivo);
    setModalOpenDoc(true);
  }

  return (
    <div>
      {(loading && <SpinnerLoading />) || (
        <div>
          <Table responsive className="table-drop2-height">
            <thead>
              <tr className="texto-menor">
                <td align="center" className="table-header">
                  Num.
                </td>

                <td align="center" className="table-header">
                  Mês/Ano ref.
                </td>

                <td align="center" className="table-header">
                  Emissão
                </td>

                <td align="center" className="table-header">
                  Vencimento
                </td>

                {isReceita && (
                  <td align="center" className="table-header">
                    Pagamento
                  </td>
                )}

                <td align="center" className="table-header">
                  Valor documento
                </td>

                <td align="center" className="table-header">
                  <small>(-)</small> Descontos
                </td>

                <td align="center" className="table-header">
                  <small>(-)</small> Devolução
                </td>

                <td align="center" className="table-header">
                  <small>(+)</small> Despesas
                </td>

                <td align="center" className="table-header">
                  <small>(+)</small> Juros
                </td>

                <td align="center" className="table-header">
                  <small>(+)</small> Multa
                </td>

                <td colSpan="2" align="center" className="table-header">
                  <small>(-)</small> Impostos
                </td>

                <td align="center" className="table-header">
                  Valor a pagar
                </td>

                <td width="6%" align="center" className="table-header">
                  Rateio
                </td>

                <td width="8%" align="right" className="table-header">
                  Posse
                </td>

                <td width="8%" align="center" className="table-header">
                  Situação
                </td>

                <td width="8%" align="center" className="table-header">
                  Docs.
                </td>
              </tr>
            </thead>

            <tbody>
              {result.items.map((pag, index) => (
                <React.Fragment key={index}>
                  <tr
                    className={
                      "tr-slim texto-menor " +
                      (numPag && numPag == pag.num_pag ? "realce-bg-cinza" : "")
                    }
                  >
                    <td align="center" className="fw-bold">
                      {pag.num_pag}
                    </td>

                    <td align="center">{pag.mes_ano_ref}</td>

                    <td align="center">{fn_formatarData(pag.data_emissao)}</td>

                    <td align="center">
                      {fn_formatarData(pag.data_vencimento)}
                    </td>

                    {isReceita && (
                      <td align="center">
                        {fn_formatarData(pag.data_pagamento)}
                      </td>
                    )}

                    <td align="center">
                      {fn_formatarNumero(pag.valor_documento, 2)}
                    </td>

                    <td align="center">
                      {fn_formatarNumero(pag.valor_desconto, 2)}
                    </td>

                    <td align="center">
                      {fn_formatarNumero(pag.valor_devolucao, 2)}
                    </td>

                    <td align="center">
                      {fn_formatarNumero(pag.valor_despesa, 2)}
                    </td>

                    <td align="center">
                      {fn_formatarNumero(pag.valor_juros, 2)}
                    </td>

                    <td align="center">
                      {fn_formatarNumero(pag.valor_multa, 2)}
                    </td>

                    <td align="right">
                      {fn_formatarNumero(pag.valor_imposto, 2)}
                    </td>
                    <td width="3%">
                      {Number(pag.valor_imposto) > 0 && (
                        <div
                          className="ms-2 btn-icone-sm"
                          onClick={() => handleBotaoImpostos(pag)}
                        >
                          {ICONES_BOTAO.DETALHAR}
                        </div>
                      )}
                    </td>

                    <td align="center">
                      {fn_formatarNumero(pag.valor_pagamento, 2)}
                    </td>

                    <td align="center">
                      {(Number(pag.num_pag) == 1 || !isParcelado) && (
                        <div
                          className="btn-icone"
                          title="Consultar rateio"
                          onClick={() => handleBotaoRateio(pag)}
                        >
                          {ICONES_SIIG.RATEIO}
                          <span className="ms-2">{pag.tipo_rateio}</span>
                        </div>
                      )}
                    </td>

                    <td align="right">
                      {(Number(pag.num_pag) == 1 || !isParcelado) && (
                        <div className="d-flex justify-content-end">
                          <div className="me-2" title="Posse realizada">
                            {pag.data_posse ? ICONES.CHECK_VERDE : ""}
                          </div>

                          <div
                            className="btn-icone"
                            onClick={() => handleBotaoDetalharPagamento(pag)}
                          >
                            {ICONES_BOTAO.DETALHAR}
                          </div>
                        </div>
                      )}
                    </td>

                    <td align="center">
                      {(Number(pag.num_pag) == 1 || !isParcelado) && (
                        <div>{fn_getJsxSituacaoPagamento(pag.situacao)}</div>
                      )}
                    </td>

                    <td>
                      {(Number(pag.num_pag) == 1 || !isParcelado) && (
                        <>
                          {pag.nome_anexo_doc && (
                            <Button
                              name="btnDocumento"
                              color="primary"
                              className="ms-2 btn-icone-sm"
                              title="Visualizar documento"
                              onClick={() =>
                                handleBotaoVisualizarDocs(pag.nome_anexo_doc)
                              }
                            >
                              {ICONES_SIIG.DOCUMENTO}
                            </Button>
                          )}
                          {pag.nome_anexo_complementar && (
                            <Button
                              name="btnDocComplementar"
                              color="primary"
                              className="ms-2 btn-icone-sm"
                              title="Visualizar doc. complementar"
                              onClick={() =>
                                handleBotaoVisualizarDocs(
                                  pag.nome_anexo_complementar,
                                )
                              }
                            >
                              {ICONES_SIIG.ANEXOS}
                            </Button>
                          )}
                          {pag.nome_anexo_forma_pag && (
                            <Button
                              name="btnDocumento"
                              color="secondary"
                              className="ms-2 btn-icone-sm"
                              title="Visualizar documento da forma pagamento"
                              onClick={() =>
                                handleBotaoVisualizarDocs(
                                  pag.nome_anexo_forma_pag,
                                )
                              }
                            >
                              {ICONES_SIIG.DOCUMENTO}
                            </Button>
                          )}
                        </>
                      )}
                    </td>
                  </tr>

                  {index == result.items.length - 1 && (
                    <tr className="tr-slim tr-border-0 texto-menor">
                      <td
                        colSpan={isReceita ? "5" : "4"}
                        align="right"
                        className="fw-bold"
                      >
                        TOTAL:
                      </td>

                      <td align="center" className="fw-bold">
                        {fn_formatarNumero(totais.valor_documento, 2)}
                      </td>

                      <td align="center" className="fw-bold">
                        {fn_formatarNumero(totais.valor_desconto, 2)}
                      </td>

                      <td align="center" className="fw-bold">
                        {fn_formatarNumero(totais.valor_devolucao, 2)}
                      </td>

                      <td align="center" className="fw-bold">
                        {fn_formatarNumero(totais.valor_despesa, 2)}
                      </td>

                      <td align="center" className="fw-bold">
                        {fn_formatarNumero(totais.valor_juros, 2)}
                      </td>

                      <td align="center" className="fw-bold">
                        {fn_formatarNumero(totais.valor_multa, 2)}
                      </td>

                      <td align="right" className="fw-bold">
                        {fn_formatarNumero(totais.valor_imposto, 2)}
                      </td>
                      <td></td>

                      <td align="center" className="fw-bold">
                        {fn_formatarNumero(totais.valor_pagamento, 2)}
                      </td>

                      <td colSpan="4"></td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </Table>

          <Paginacao
            result={result}
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
          />
        </div>
      )}

      {/* MODAL IMPOSTOS */}
      {modalOpenImpostos && (
        <div>
          <TImpostos_cad
            modalOpen={modalOpenImpostos}
            toggleModal={() => setModalOpenImpostos(!modalOpenImpostos)}
            pagamentoEdit={pagamentoCons}
            valoresEdit={fn_agruparTotal(
              pagamentoCons.impostos,
              ["id_imposto"],
              "valor",
            )}
            readOnly={true}
          />
        </div>
      )}

      {/* MODAL RATEIO */}
      {modalOpenRateio && (
        <div>
          <TRateio_det
            modalOpen={modalOpenRateio}
            toggleModal={() => setModalOpenRateio(!modalOpenRateio)}
            pagamento={pagamentoCons}
            isParcelado={isParcelado}
          />
        </div>
      )}

      {/* DETALHAR PAGAMENTO */}
      {modalOpenPagDet && (
        <div>
          <TPag_det_posse
            modalOpen={modalOpenPagDet}
            toggleModal={() => setModalOpenPagDet(!modalOpenPagDet)}
            solicitacao={solicitacao}
            pagamento={pagamentoCons}
          />
        </div>
      )}

      {modalOpenDoc && (
        <ModalViewArquivo
          pastaArquivo={fn_getPastaUploadSolicitacao(
            fn_getPathTenant(sessaoUsuario),
            solicitacao.numero,
          )}
          nomeArquivo={nomeAnexoView}
          solicitacao={solicitacao} //título com o tipo e o pagamento do arquivo
          isOpen={modalOpenDoc}
          toggleModal={() => setModalOpenDoc(!modalOpenDoc)}
          flutuante={true}
        />
      )}
    </div>
  );
}

export default TPagamentos_list;
